import { Config } from '@nw/shared/config';

export const isPaymentEnabled = (): boolean => {
  return Config.ENABLE_PAYMENTS === '1' ? true : false;
};

export const isGammaOrProdEnv = (): boolean => {
  return (
    Config['ENVIRONMENT'] === 'gamma' || Config['ENVIRONMENT'] === 'ccbp_prod'
  );
};
